import Work1 from '../../assets/work-1.png';
import Work2 from '../../assets/work-2.png';
import Work3 from '../../assets/work-3.png';
import Work4 from '../../assets/work-4.png';
import Work5 from '../../assets/work-5.png';
import Work6 from '../../assets/work-6.png';
import Work7 from '../../assets/work-7.png';

const Menu = [
    {
        id: 1,
        image: Work1,
        title: 'Enjoy TheBest FreshFruits',
        category: ['HTML'],
        url: 'https://spiffy-gelato-eff2eb.netlify.app/',
    },
    {
        id: 2,
        image: Work2,
        title: 'Volti Website Project',
        category: ['HTML'],
        url: 'https://jitendra1419p.github.io/Volti_website_project/',
        // repositoryUrl: 'https://github.com/GregSithole/crypto-app',
    },
    {
        id: 3,
        image: Work3,
        title: 'Calypso Learning Services',
        category: ['HTML'],
        url: 'https://jitendra1419p.github.io/Calypso_Learning_Services/',
    },
    {
        id: 4,
        image: Work6,
        title: 'Hotel Booking App',
        category: ['React'],
        url: 'https://hotel-booking-app-ten-tau.vercel.app/',
    },
    {
        id: 5,
        image: Work7,
        title: 'Furniture Store',
        category: ['React'],
        url: 'https://furniturestarter-poyd4290k-jitendra1419ps-projects.vercel.app/',
    },
    {
        id: 6,
        image: Work5,
        title: 'Dashboard App',
        category: ['React'],
        url: 'https://dashboard-app-9f100.web.app/',
    },
];

export default Menu;
